import Qualite from '@/generated/classes/Qualite';
export default class QualiteExtend extends Qualite {
  constructor() {
    super();
  }
}
